module.exports = __webpack_public_path__ + "static/media/LogowithoutWords.c0e3037cb99571a56a1c854fa3529ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/LogowithoutWords.png
// module id = 1171
// module chunks = 1